export default __webpack_public_path__ + "static/media/zoom-in.4319c4bb.svg";